import { UserRole, UserType } from "../services/api/types.js";
import { userStore } from "../services/stores/user-store.js";
import { get } from "svelte/store";
import { logError, logInfo, logWarning } from "../services/logging/log-handler.js";

function formatDate(dateString: string) {
  const date = new Date(dateString);
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();

  const day = date.getDate().toString();
  const month = date.toLocaleString("en-GB", { month: "short" }).toUpperCase();

  if (dateYear === currentYear) {
    return `${day}-${month}`;
  }
  return `${day}-${month}-${dateYear}`;
}

function formatTime(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

function currentDateAndTime() {
  const date = new Date();
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" }).toUpperCase();
  const year = date.getFullYear();
  return `${day}-${month}-${year} `;
}

function userName() {
  const { user } = get(userStore);
  return user?.name || "";
}

function userRole() {
  const { user } = get(userStore);
  const role = user?.user_role;
  if (role && ![UserRole.ADMIN, UserRole.VIEWER].includes(role)) {
    logError(new Error("User role is not valid"), "helpers", undefined, {role: role});
    return UserRole.VIEWER;
  }
  return role;
}

function userType() {
  const { user } = get(userStore);
  const userType = user?.user_type;
  if (!userType || !Object.values(UserType).includes(userType)) {
    logError(new Error("User type is not valid"), "helpers", undefined, {userType: userType});
    return UserType.CUSTOMER;
  }
  return userType;
}

function formatToProperCase(text: string): string {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function getDocKey(docPath: string): string {
  if (!docPath) return "";
  if (docPath.includes(".")) {
    return docPath.split(".")[0];
  }
  return docPath;
}

export function formatUserType(userType: string): string {
  if (!userType) return "";

  switch (userType.toLowerCase()) {
    case "oh-user":
      return "OH User";
    default:
      return formatToProperCase(userType);
  }
}

export { formatDate, formatTime, currentDateAndTime, userName, userRole, userType, formatToProperCase, getDocKey };
